import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, vModelRadio as _vModelRadio, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-2" }
const _hoisted_2 = { class: "row align-items-center" }
const _hoisted_3 = { class: "col-md-8" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "breadcrumb-wrap mt-1" }
const _hoisted_6 = { "aria-label": "breadcrumb" }
const _hoisted_7 = { class: "breadcrumb mb-0" }
const _hoisted_8 = /*#__PURE__*/_createVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
    /*#__PURE__*/_createVNode("i", { class: "fa fa-home" })
  ])
], -1)
const _hoisted_9 = {
  class: "breadcrumb-item active",
  "aria-current": "page"
}
const _hoisted_10 = {
  href: "javascript:void(0)",
  class: "breadcrumb-item active"
}
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = { class: "text-sm-right" }
const _hoisted_13 = {
  href: "javascript:void(0)",
  class: "btn default-btn d-inline-block"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("i", { class: "fa fa-chevron-left" }, null, -1)
const _hoisted_15 = { class: "card" }
const _hoisted_16 = { class: "create-form" }
const _hoisted_17 = { class: "form-wrap pt-0" }
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = { for: "" }
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = { for: "mobile" }
const _hoisted_22 = { class: "inline-items" }
const _hoisted_23 = { class: "custom-control custom-radio" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode()
const _hoisted_25 = {
  class: "custom-control-label uppercase-text",
  for: "customRadio1"
}
const _hoisted_26 = { class: "custom-control custom-radio" }
const _hoisted_27 = {
  class: "custom-control-label to-upper",
  for: "customRadio2"
}
const _hoisted_28 = { class: "custom-control custom-radio" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode()
const _hoisted_30 = {
  class: "custom-control-label",
  for: "customRadio3"
}
const _hoisted_31 = {
  key: 0,
  class: "form-group"
}
const _hoisted_32 = { for: "mobile" }
const _hoisted_33 = { class: "editor-wrap tutorial-editor" }
const _hoisted_34 = {
  key: 1,
  class: "form-group"
}
const _hoisted_35 = { for: "mobile" }
const _hoisted_36 = {
  key: 2,
  class: "form-group"
}
const _hoisted_37 = { class: "custom-file" }
const _hoisted_38 = {
  class: "custom-file-label",
  for: "mobile"
}
const _hoisted_39 = {
  key: 0,
  class: "shadowed-card bg-white mb-2 mt-2"
}
const _hoisted_40 = { class: "imaged-col" }
const _hoisted_41 = { class: "small-img-wrap" }
const _hoisted_42 = { class: "form-group" }
const _hoisted_43 = { for: "mobile" }
const _hoisted_44 = { class: "text-right" }
const _hoisted_45 = { class: "modal-wrap default-modal" }
const _hoisted_46 = { class: "modal-dialog" }
const _hoisted_47 = { class: "modal-content" }
const _hoisted_48 = { class: "modal-header" }
const _hoisted_49 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_50 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "close",
  "data-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
], -1)
const _hoisted_51 = /*#__PURE__*/_createVNode("div", { class: "modal-body" }, [
  /*#__PURE__*/_createVNode("div", { class: "iframe-wrap" })
], -1)
const _hoisted_52 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_Editor = _resolveComponent("Editor")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t('edit_tutorial')), 1),
          _createVNode("div", _hoisted_5, [
            _createVNode("nav", _hoisted_6, [
              _createVNode("ol", _hoisted_7, [
                _hoisted_8,
                _createVNode("li", _hoisted_9, [
                  _createVNode("a", _hoisted_10, _toDisplayString(_ctx.$t('edit_tutorial')), 1)
                ])
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_11, [
          _createVNode("div", _hoisted_12, [
            _createVNode(_component_router_link, { to: { name: 'admin-tutorial-management' } }, {
              default: _withCtx(() => [
                _createVNode("a", _hoisted_13, [
                  _hoisted_14,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('back')), 1)
                ])
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_15, [
      _createVNode("div", _hoisted_16, [
        _createVNode("div", _hoisted_17, [
          _createVNode(_component_ErrorList, {
            errors: _ctx.state.ui.error.validationList,
            hasError: _ctx.state.ui.error.hasError
          }, null, 8, ["errors", "hasError"]),
          _createVNode("div", _hoisted_18, [
            _createVNode("label", _hoisted_19, _toDisplayString(_ctx.$t('question')), 1),
            _withDirectives(_createVNode("input", {
              type: "text",
              id: "question",
              name: "question",
              class: "form-control",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.data.question = $event)),
              placeholder: _ctx.$t('eg_question') 
            }, null, 8, ["placeholder"]), [
              [_vModelText, _ctx.state.data.question]
            ])
          ]),
          _createVNode("div", _hoisted_20, [
            _createVNode("label", _hoisted_21, _toDisplayString(_ctx.$t('tutorial_type')), 1),
            _createVNode("div", _hoisted_22, [
              _createVNode("ul", null, [
                _createVNode("li", null, [
                  _createVNode("div", _hoisted_23, [
                    _withDirectives(_createVNode("input", {
                      class: "custom-control-input",
                      id: "customRadio1",
                      type: "radio",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.data.tuorialType = $event)),
                      value: "faq",
                      disabled: _ctx.state.data.tuorialType!='faq'
                    }, null, 8, ["disabled"]), [
                      [_vModelRadio, _ctx.state.data.tuorialType]
                    ]),
                    _hoisted_24,
                    _createVNode("label", _hoisted_25, _toDisplayString(_ctx.$t('faq')), 1)
                  ])
                ]),
                _createVNode("li", null, [
                  _createVNode("div", _hoisted_26, [
                    _withDirectives(_createVNode("input", {
                      class: "custom-control-input",
                      id: "customRadio2",
                      type: "radio",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.data.tuorialType = $event)),
                      value: "video",
                      disabled: _ctx.state.data.tuorialType!='video'
                    }, null, 8, ["disabled"]), [
                      [_vModelRadio, _ctx.state.data.tuorialType]
                    ]),
                    _createVNode("label", _hoisted_27, _toDisplayString(_ctx.$t('video')), 1)
                  ])
                ]),
                _createVNode("li", null, [
                  _createVNode("div", _hoisted_28, [
                    _withDirectives(_createVNode("input", {
                      class: "custom-control-input",
                      id: "customRadio3",
                      type: "radio",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.data.tuorialType = $event)),
                      value: "pdf",
                      disabled: _ctx.state.data.tuorialType!='pdf'
                    }, null, 8, ["disabled"]), [
                      [_vModelRadio, _ctx.state.data.tuorialType]
                    ]),
                    _hoisted_29,
                    _createVNode("label", _hoisted_30, _toDisplayString(_ctx.$t('pdf')), 1)
                  ])
                ])
              ])
            ])
          ]),
          (_ctx.state.data.tuorialType == 'faq')
            ? (_openBlock(), _createBlock("div", _hoisted_31, [
                _createVNode("label", _hoisted_32, _toDisplayString(_ctx.$t('answer')), 1),
                _createVNode("div", _hoisted_33, [
                  _createVNode(_component_Editor, {
                    showEnterSetting: false,
                    usedEditor: 'tutorial',
                    modelValue: _ctx.state.data.answer,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.data.answer = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.state.data.tuorialType == 'video' || _ctx.state.data.tuorialType == 'faq')
            ? (_openBlock(), _createBlock("div", _hoisted_34, [
                _createVNode("label", _hoisted_35, _toDisplayString(_ctx.$t('video_url')), 1),
                _withDirectives(_createVNode("input", {
                  type: "url",
                  id: "videoUrl",
                  name: "video url",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.data.videoUrl = $event)),
                  placeholder: _ctx.$t('enter_youtube_url')
                }, null, 8, ["placeholder"]), [
                  [_vModelText, _ctx.state.data.videoUrl]
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.state.data.tuorialType == 'pdf' || _ctx.state.data.tuorialType == 'faq')
            ? (_openBlock(), _createBlock("div", _hoisted_36, [
                _createVNode("div", _hoisted_37, [
                  _createVNode("input", {
                    class: "custom-file-input",
                    type: "file",
                    multiple: "",
                    accept: "*.*",
                    id: "profileUpdate",
                    onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onDocumentChange($event)))
                  }, null, 32),
                  _createVNode("label", _hoisted_38, _toDisplayString(_ctx.$t('choose_pdf')), 1)
                ]),
                (_ctx.state.data.uploadFIle.fileName)
                  ? (_openBlock(), _createBlock("div", _hoisted_39, [
                      _createVNode("div", _hoisted_40, [
                        _createVNode("a", {
                          href: _ctx.state.selectedFileUrl,
                          title: _ctx.$t('click_to_show'),
                          target: "_blank"
                        }, [
                          _createVNode("div", _hoisted_41, [
                            _createVNode("img", {
                              src: 
                        _ctx.state.data.imageBaseUrl
                          ? `${_ctx.state.data.imageBaseUrl}img/pdf.png`
                          : 'img/pdf.png'
                      ,
                              alt: ""
                            }, null, 8, ["src"])
                          ]),
                          _createVNode("h5", null, _toDisplayString(_ctx.state.data.uploadFIle.fileName), 1)
                        ], 8, ["href", "title"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_42, [
            _createVNode("label", _hoisted_43, _toDisplayString(_ctx.$t('sort_order')), 1),
            _withDirectives(_createVNode("input", {
              type: "number",
              id: "sort order",
              name: "sort order",
              class: "form-control",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.state.data.sortOrder = $event)),
              placeholder: _ctx.$t('enter_youtube_url')
            }, null, 8, ["placeholder"]), [
              [_vModelText, _ctx.state.data.sortOrder]
            ])
          ]),
          _createVNode("div", _hoisted_44, [
            _createVNode("a", {
              class: "btn default-btn",
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.saveTutorial && _ctx.saveTutorial(...args)))
            }, _toDisplayString(_ctx.$t('update')), 1)
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_45, [
      _createVNode("div", {
        class: "modal fade",
        id: "showModel",
        tabindex: "-1",
        "aria-labelledby": "exampleModalLabel",
        "aria-hidden": "true",
        onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.closeShowModel && _ctx.closeShowModel(...args)))
      }, [
        _createVNode("div", _hoisted_46, [
          _createVNode("div", _hoisted_47, [
            _createVNode("div", _hoisted_48, [
              _createVNode("h5", _hoisted_49, _toDisplayString(_ctx.state.selectedFileName), 1),
              _hoisted_50
            ]),
            _hoisted_51,
            _createVNode("div", _hoisted_52, [
              _createVNode("button", {
                type: "button",
                class: "btn btn-secondary",
                "data-dismiss": "modal",
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.closeShowModel && _ctx.closeShowModel(...args)))
              }, _toDisplayString(_ctx.$t('cancel')), 1)
            ])
          ])
        ])
      ])
    ]),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 0,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.successFulMessage
        }, null, 8, ["onClose", "showModal", "titleMessage"]))
      : _createCommentVNode("", true)
  ]))
}